import React, { useEffect, useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { getOtp, verifyOtp } from '../../api';
import {
  getLocalStorageData,
  getUserToken,
  setLocalStorageData,
} from '../../common/resubale-functions';
import { Spinner } from 'reactstrap';
import swal from 'sweetalert';
import http from '../../api/api';
import {
  bankpay_consumer_token,
  bankpay_consumer_user_id,
} from '../../common/constants';
import { MainContext } from '../context/context';
import { famPrivacy, famTerms, googlePrivacy, googleTerms } from '../../common/constants';
import background from '../../assets/images/login-bg.png'
import { toast } from 'react-toastify';
import mixpanel from 'mixpanel-browser';

const OTPPage = ({
  phoneNumber,
  handleChangeNumber,
  setIscontinue,
  isContinue,
  selectedCountry,
  setLOginToken,
  loginToken,
}) => {
  const context = useContext(MainContext);
  const { loginTokenContext, setLOginTokenContext, setUserIdContext } = context;
  const history = useHistory();
  const search = useLocation().search;
  const redirectTo = new URLSearchParams(search).get('redirectTo');
  const [otp, setOtp] = useState('');
  const [student, setstudent] = useState({});
  const [remTime, setRemTime] = useState(30);
  const [showRemTime, setShowRemTime] = useState(true);
  const [isVerifying, setVerify] = useState(false);
  const [otpVerifyStatus, setOtpStatus] = useState('');
  const [isResendOtp, setResendOtp] = useState(false);
  const [fireBaseToken, setFirebaseToken] = useState('');
  const [isTokenFound, setTokenFound] = useState(false);

  const formatToStr = (time) => {
    const min = Math.floor(time / 60);
    const sec = time - min * 60;

    return `${sec.toString().length === 2 ? sec : '0' + sec}`;
  };

  useEffect(() => {
    const timer = setInterval(() => {
      if (remTime === 0) setShowRemTime(false);
      setRemTime(remTime <= 0 ? 0 : remTime - 1);
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  });

  useEffect(() => {
    if (otp?.length == 6) handleSubmit();
  }, [otp]);

  useEffect(() => {
    if (isResendOtp == true)
      setTimeout(() => {
        setResendOtp(false);
      }, 5000);
  }, [isResendOtp]);

  const handleOtp = (otp) => setOtp(otp);

  const handleResendOtp = async () => {
    setShowRemTime(true);
    setRemTime(30);
    let num = selectedCountry?.dial_code.concat(phoneNumber);
    try {
      const payload = {
        phone_number: num,
        check_exists: false,
        touchpoint: "WEB_CONSUMER"
      }
      const res = await getOtp(payload);
      setResendOtp(res.data.code == 200 ? true : false);
    } catch (e) {
      toast.error('Something Went Wrong');
    }
    // const otp = JSON.stringify(res.otp);
    // // swal({
    // //   title: res.status,
    // //   text: `OTP : ${otp}`,
    // //   icon: "success",
    // // });
  };

  const handleSubmit = async (e) => {
    try {
      if (otp === '') {
        swal({
          title: 'failure',
          text: 'No OTP submitted',
          icon: 'error',
        });
      } else {
        setVerify(!isVerifying);
        setOtpStatus('Verifying...');
        let num = selectedCountry?.dial_code.concat(
          phoneNumber.replace(/^0+/, '')
        );
        const res = await verifyOtp({
          phone_number: num,
          code: otp,
        });
        if (res?.data?.code == 400) {
          setOtpStatus('Invalid code. Please try again.');
          swal({
            title: res.data.status,
            text: res.data.message,
            icon: 'error',
          });
        } else if (res?.data?.code == 200) {
          // localStorage.setItem(
          //   'bankpay_consumer_token',
          //   res.data?.data?.access_token
          // );
          mixpanel.track("Logged In", {
                  touch_point: "web",
                  distinct_id: res.data?.data?.user?.unique_id,
              },
              {send_immediately: true}
          );
          setLOginTokenContext(res.data?.data?.access_token);
          setUserIdContext(res.data?.data?.user?.unique_id);
          http.defaults.headers.common[
            'Authorization'
          ] = `JWT ${res.data?.data?.access_token}`;
          setLocalStorageData(
            bankpay_consumer_token,
            res.data?.data?.access_token
          );
          console.log('---',res.data?.data?.user?.unique_id)
          setLocalStorageData(
            bankpay_consumer_user_id,
            res.data?.data?.user?.unique_id
          );
          console.log(getLocalStorageData(bankpay_consumer_user_id, 'string'))
          // localStorage.setItem(
          //   'bankpay_consumer_user_id',
          //   res.data?.data?.user?.end_user_id
          // );
          setLOginToken(res.data?.data?.access_token);
          setOtpStatus('');
          setVerify(false);
          if (getUserToken()) {
            // Redirect to the specified URL if redirectTo param exists, otherwise go to credits
            if (redirectTo) {
              history.push(redirectTo);
            } else {
              history.push('/credits');
            }
          }
        }
      }
    } catch (e) {
      mixpanel.track("Provided OTP has failed", {
              touch_point: "consumer web",
          }
      );
      setVerify(false);
      setOtpStatus(`${e?.response?.data?.errors[0]?.detail}`);
      toast.error('Something Went Wrong');
    }
  };

  const brandLogin = () => {
    window.open('https://merchant.joinfam.com/', '_blank');
  }

  return (
    <div className="login-wrap">
      <div className="login-inner flex flex-col">
        <div className="login-inner-top grow flex justify-evenly min-h-screen">
          <div className="login-left flex flex-col px-5 md:px-10 lg:px-20 w-full lg:w-1/2 gap-4 py-10 pb-5">
            <div className="login-left-top grow">
              <div className="login-left-title text-2xl text-[#0F0F0F] font-Rany font-bold flex gap-3 items-center">
                <div className='cursor-pointer' onClick={() => setIscontinue(!isContinue)}>
                  <svg width="10" height="20" viewBox="0 0 12 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.318605 12.8566L10.1195 23.6457C10.5496 24.1181 11.2463 24.1181 11.6775 23.6457C12.1075 23.1733 12.1075 22.4061 11.6775 21.9337L2.65396 12.0006L11.6764 2.06752C12.1064 1.59513 12.1064 0.827864 11.6764 0.354284C11.2463 -0.118097 10.5485 -0.118097 10.1184 0.354284L0.317519 11.1434C-0.106022 11.6109 -0.106022 12.3903 0.318605 12.8566Z" fill="#0F0F0F" />
                  </svg>
                </div>
                <span>Verify <span className="hidden md:inline-block">phone number</span> <span className="inline-block md:hidden">login</span></span>
              </div>
              <div className="login-left-form w-full xl:w-8/12 mt-6">
                <div className="login-left-sub-title text-[#6C757D] text-sm mb-6">
                  Enter the 6 digit code sent to your phone to verify who you are and log in.
                </div>
                <div className="login-input relative">
                  <div
                    className={`enter-otp ${isVerifying ? 'verify_otp' : otpVerifyStatus ? 'error-style' : ''
                      }`}
                  >
                    <input
                      type="tel"
                      value={otp}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, '').slice(0, 6);
                        handleOtp(value);
                      }}
                      maxLength={6}
                      placeholder="Enter 6-digit code"
                      autoFocus={true}
                      className="form-input border text-base text-[#0F0F0F] border-[#DEE2E6] focus:border-[#0F0F0F] focus:outline-none rounded-lg w-full py-4 px-4 placeholder-[#ADB5BD] tracking-[0.3em] text-center text-lg"
                    />
                  </div>
                  <div className="h-6 mt-2">
                    {otpVerifyStatus && isVerifying == true ? (
                      <span className="flex items-center text-sm">
                        <Spinner
                          style={{
                            width: '1rem',
                            height: '1rem',
                            fontSize: '10px',
                            color: '#000000',
                            marginRight: '8px',
                          }}
                        />
                        <span className='varifying-text'>Verifying...</span>
                      </span>
                    ) : (
                      <span className='otp-failure-status text-sm'>{otpVerifyStatus}</span>
                    )}
                  </div>
                  {/* <input type="number"
                                    maxLength={6}
                                    className="form-input border text-base text-[#0F0F0F] border-[#DEE2E6] focus:border-[#DEE2E6] rounded-lg mb-4 w-full p-4 placeholder-[#ADB5BD]" placeholder="Verification Code" /> */}
                </div>
                <div className="login-adon text-sm text-[#0F0F0F] flex gap-4 justify-between mt-4">
                  {isResendOtp ? (
                    <span>Code sent again!</span>
                  ) : (
                    <div>
                      {showRemTime ? (
                        <div>
                          Code didn’t arrive? <span className="text-[#ADB5BD]">Resend in {formatToStr(remTime)}...</span>
                        </div>
                      ) : (
                        <button disabled={!showRemTime ? false : true} onClick={handleResendOtp}>
                          Resend code
                        </button>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="login-left-bottom shrink-0 text-sm text-[#ADB5BD] lg:pt-10">
              <svg className='h-10 w-40 text-[#FEE600] mb-4' width="160" height="40" viewBox="0 0 160 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19.4256 10.1714V17.0286H43.4606V27.2H19.4256V40H0V0H46.8354V10.1714H19.4256Z" fill="#0F0F0F" />
                <path d="M76.975 33.0286H55.0801L51.2114 40H31.4566L56.644 0H75.7404L100.928 40H80.8437L76.975 33.0286ZM71.6248 23.3143L66.0276 13.2571L60.4304 23.3143H71.6248Z" fill="#0F0F0F" />
                <path d="M142.303 40L142.138 21.7714L129.627 36.4H121.067L108.555 22.4V40H90.8581V0H106.827L125.594 21.3143L143.867 0H159.835L160 40H142.303Z" fill="#0F0F0F" />
              </svg>
              <p className="mb-2">By continuing, I accept the <a target="_blank" href={famTerms} className="hover:text-[#000] underline">Fam Terms of
                Service</a> and confirm that I have read <a target="_blank" href={famPrivacy} className="hover:text-[#000] underline">Fam’s Privacy Notice</a>.
              </p>
              <p className="mb-2">This page is protected by reCAPTCHA. By continuing I confirm having read Google’s <a target="_blank" href={googlePrivacy} className="hover:text-[#000] underline">Privacy Policy</a> and accepted Google’s
                <a target="_blank" href={googleTerms} className="hover:text-[#000] underline"> Terms</a>.
              </p>
              <p className="mb-2">Message and data rates may apply.</p>
            </div>
          </div>
          <div className="login-right w-1/2 py-10 px-20 bg-center bg-cover bg-no-repeat shrink-0 hidden lg:block"
            style={{ backgroundImage: `url(${background})` }}>
            <div className="login-right-action flex gap-2 items-center justify-end w-full">
              <button onClick={() => brandLogin()} className="form-btn hover:opacity-90 brand-login font-bold font-Rany">
                <div className="btn-container">
                  <div>Brand login</div>
                  <div>
                    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M16.7071 8.70711C17.0976 8.31658 17.0976 7.68342 16.7071 7.29289L10.3431 0.928932C9.95262 0.538408 9.31946 0.538408 8.92893 0.928932C8.53841 1.31946 8.53841 1.95262 8.92893 2.34315L14.5858 8L8.92893 13.6569C8.53841 14.0474 8.53841 14.6805 8.92893 15.0711C9.31946 15.4616 9.95262 15.4616 10.3431 15.0711L16.7071 8.70711ZM0 9H16V7H0V9Z" fill="#0F0F0F" />
                    </svg>
                  </div>
                </div>
              </button>
            </div>
          </div>
        </div>
        <div className="font-Rany login-inner-bottom shrink-0 px-5 md:px-10 lg:px-20 py-[34px] flex gap-4 justify-between items-center bg-[#0F0F0F] flex-col lg:flex-row text-center lg:text-left">
          <div className="login-bottom-left grow text-white text-base">
            Copyright © 2023 Frictionless Technologies Ltd.
          </div>
          <div className="login-bottom-right">
            <ul className="login-bottim-link flex gap-2 lg:gap-4 flex-col lg:flex-row text-center lg:text-right">
              <li><a href="mailto:support@joinfam.com" className="text-base text-[#ADB5BD] hover:underline">Help</a></li>
              <li><a target="_blank" href={famTerms} className="text-base text-[#ADB5BD] hover:underline">Terms of Service</a></li>
              <li><a target="_blank" href={famPrivacy} className="text-base text-[#ADB5BD] hover:underline">Privacy Policy</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OTPPage;
